<div class="access-container settings-page">

  <div class="settings-page__content">
    @if (!isRoleEditorActive()) {
      <p class="settings-page__description">
        {{ 'SETTINGS_ACCESS.DESCRIPTION' | translate }}
      </p>
    }
    <p-tabs [value]="activeTab()" (valueChange)="onTabChange('' + $event)">
      @if (!isRoleEditorActive()) {
        <p-tablist>
          <p-tab value="users">{{ 'SETTINGS_ACCESS.USERS.TITLE' | translate }}</p-tab>
          <p-tab value="roles">{{ 'SETTINGS_ACCESS.ROLES.TITLE' | translate }}</p-tab>
        </p-tablist>
      }

      <p-tabpanels>
        <p-tabpanel value="users">
          <tf-settings-users-list />
        </p-tabpanel>

        <p-tabpanel value="roles">
          <tf-settings-roles-list
            [rolesSearchQuery]="roleSearchQuery()"
            [rolesTypeFilter]="roleTypeFilter()"
            (rolesSearchQueryChange)="onRoleSearchQueryChange($event)"
            (rolesTypeFilterChange)="onRoleTypeFilterChange($event)" />
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
  @if (isRoleEditorActive()) {
    <tf-settings-actions
      [cancelDisabled]="isRoleEditorSaving()"
      [saveDisabled]="isRoleEditorSaveDisabled()"
      [loading]="isRoleEditorSaving()"
      [saveLabelKey]="'SETTINGS_ACCESS.ROLES.SAVE_CHANGES'"
      (cancelled)="rolesList()?.backToRoles()"
      (save)="rolesList()?.saveRole()" />
  }
</div>
